import React from 'react';
import './QuantityField.scss';
import RoundButtonIcon from '../round-button-icon/RoundButtonIcon';
import clsx from 'clsx';

/**
 * A quantity input field
 * @param max The maximum quantity input allowed
 * @param quantity The quantity field state
 * @param setQuantity Function to set quantity field state
 * @param quantityMessage Validation message displayed on error
 * @returns JSX Element
 */

const QuantityField = ({ max, quantity, setQuantity, quantityMessage, className = '' }) => {
  const minusButtonInactive = quantity <= 1;
  const plusButtonInactive = quantity >= max;
  const error = quantity % 1 !== 0;

  const handleInputChange = (e) => {
    const inputVal = e.target.value;

    inputVal === ''
      ? setQuantity(inputVal)
      : setQuantity(Math.max(1, Math.min(max ? max : Infinity, Number(inputVal))));
  };

  const clickMinusButton = () => {
    if (minusButtonInactive) return undefined;

    setQuantity((quantity) => quantity - 1);
  };

  const clickPlusButton = () => {
    if (plusButtonInactive) return undefined;

    setQuantity((quantity) => (quantity === '' ? 1 : quantity + 1));
  };

  return (
    <div className={`quantity-field ${className}`}>
      <div className='quantity-field__content'>
        <RoundButtonIcon
          plusIcon={false}
          buttonColor={'blue'}
          iconColor={'white'}
          onClick={clickMinusButton}
          inactive={minusButtonInactive}
          alt={'Subtract 1'}
        />
        <div className='quantity-field__input'>
          <input
            name={'quantity'}
            type={'number'}
            value={quantity}
            onChange={handleInputChange}
            step='any'
            className={clsx('quantity-field__input-field', { 'quantity-field__input-field--error': quantityMessage })}
            aria-invalid={error}
          />
        </div>
        <RoundButtonIcon
          plusIcon={true}
          buttonColor={'blue'}
          iconColor={'white'}
          onClick={clickPlusButton}
          inactive={plusButtonInactive}
          alt={'Add 1'}
        />
      </div>
      {quantityMessage && <div className={'quantity-field__message'}>{quantityMessage}</div>}
    </div>
  );
};

export default QuantityField;
